define(
  'app/views/newsletter_mobile_subscription_box_view',['app/setup', 'app/views/newsletter_view'],
  function(takhfifan, newsletterView) {

  takhfifan.newsletterMobileSubscriptionBoxView = takhfifan.NewsletterView.extend({

    events: {
      'click button': 'submit',
      'submit': 'submit',
      'click li': 'setCity'
    },

    initialize: function(options) {
      this.model.on('submit:success', this.success, this);
      this.model.on('submit:invalid', this.renderErrors, this);
      Backbone.Validation.bind(this);
    },

    renderErrors: function() {
      this.$('.mobile-newsletter-alert').remove();
      this.$("#mobile-newsletter-text").after(
        '<div class="alert alert-red mobile-newsletter-alert">'+
        '<span class="icon-close"></span> <p>ارتباط برقرار نشد.</p> </div>');
    },

    success: function() {
      this.$('.mobile-newsletter-alert').remove();
      this.$("#mobile-newsletter-text").after(
        '<div class="alert alert-green mobile-newsletter-alert">'+
        '<span class="icon-check"></span> <p>با موفقیت ثبت شد.</p> </div>');
      this.$('input[name=email]').val('');
      this.setCookie({
        name: this.cookie_success,
        expires: 28
      });
    }

  });
});

